type Rules = {
    required?: boolean;
    minLength?: number;
    maxLength?: number;
};

export function validateTextField(
    value: string,
    fieldLabel: string,
    rules: Rules
) {
    const safeValue = value ?? "";
    const trimValue = safeValue.trim();

    // Se for obrigatório
    if (rules.required && trimValue.length === 0) {
        return `${fieldLabel} é obrigatório.`;
    }

    // Se NÃO é obrigatório e está vazio → OK
    if (!rules.required && trimValue.length === 0) {
        return null;
    }

    // Se tem valor, valida minLength
    if (rules.minLength && trimValue.length < rules.minLength) {
        return `${fieldLabel} deve ter pelo menos ${rules.minLength} caracteres.`;
    }

    // Se tem valor, valida maxLength
    if (rules.maxLength && trimValue.length > rules.maxLength) {
        return `${fieldLabel} deve ter no máximo ${rules.maxLength} caracteres.`;
    }

    return null;
}